class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('#predictive-search');

    if (!this.input || !this.predictiveSearchResults) return;

    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));

    this.input.addEventListener('focus', () => {
      const searchTerm = this.input.value.trim();

      if (searchTerm.length && this.predictiveSearchResults.innerHTML.trim()) {
        this.open();
      }
    });

    document.addEventListener('click', (event) => {
      if (!this.contains(event.target)) {
        this.close();
      }
    });
  }

  onChange() {
    const searchTerm = this.input.value.trim();

    if (!searchTerm.length) {
      this.close();
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    fetch(`/search/suggest?q=${encodeURIComponent(searchTerm)}&resources[type]=product&resources[limit]=4&section_id=predictive-search`)
      .then((response) => {
        if (!response.ok) {
          const error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const html = new DOMParser().parseFromString(text, 'text/html');
        const section = html.querySelector('#shopify-section-predictive-search');

        if (!section) {
          console.warn('[Predictive Search] Missing #shopify-section-predictive-search section.');
          this.close();
          return;
        }

        this.predictiveSearchResults.innerHTML = section.innerHTML;
        this.open();
      })
      .catch((error) => {
        console.log(error);
        this.close();
      });
  }

  open() {
    this.predictiveSearchResults.style.display = 'block';
    this.setAttribute('open', true);
  }

  close() {
    this.predictiveSearchResults.style.display = 'none';
    this.removeAttribute('open');
  }

  debounce(fn, wait) {
    let t;

    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

if (!customElements.get('predictive-search')) {
  customElements.define('predictive-search', PredictiveSearch);
}
